<template>
    <div v-bind:class="[className]">
        <div class="panel panel-default">
            <a
                v-if="showEditModal"
                @click.prevent="showEditModal(contact)"
                href="#"
                class="panel-heading"
            >
                {{headTitle}}
                <i class="fa fa-pencil edit-pencil"></i>
            </a>
            <div v-else class="panel-heading">
                {{headTitle}}
            </div>
            <div class="panel-body list-group">
                <div class="list-group-item"
                     v-if="contact.birth_date">
                    <div class="lgi-inner">
                            <span>
                                <i class="fa fa-birthday-cake"></i>&nbsp;
                            </span>
                            <span>
                                {{ contact.birth_date | date 'LL' }}
                            </span>
                    </div>
                </div>
                <div class="list-group-item" v-if="contact.position">
                    <div class="lgi-inner">
                            <span>
                                <i :class="{
                                    'fa fa-user': isCompanyContact,
                                    'fa fa-briefcase': !isCompanyContact,
                                    }"></i>&nbsp;
                            </span>
                            <span>
                                {{firstLine}}
                            </span>
                    </div>
                </div>
                <div class="list-group-item"
                     v-for="info in contact.info | orderBy 'type'">
                    <a v-if="info.type === 'phone'"
                       class="-phone"
                       :href="'tel:' + info.value">
                        <span>
                            <i class="glyphicon glyphicon-earphone"></i>
                        </span>
                        <span>
                            {{ info.value | phone }}
                        </span>
                    </a>
                    <a :href="'mailto:' + info.value"
                       class="-email"
                       v-if="info.type === 'email'">
                        <span>
                            <i class="glyphicon glyphicon-envelope"></i>
                        </span>
                        <span>
                            {{ info.value }}
                        </span>
                    </a>
                    <a v-if="info.type === 'address'"
                       class="-address"
                       target="_blank"
                       :href="addressLink(info.value)">
                        <span>
                            <i class="glyphicon glyphicon-home"></i>
                        </span>
                        <span>
                            {{{ info.value | address }}}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" type="text/less" scoped>
    @import '~src/style/variables';
    a.panel-heading {
        display: block;

        &:hover {
            text-decoration: none;
        }
    }

    /**
     * Contact not being editable, we don't want to
     */
    .edit-pencil {
        visibility: hidden;
        a:hover & {
            visibility: visible;
        }
    }
    .list-group-item {
        padding: 0;

        > * {
            padding: 16px 24px;
        }

        .lgi-inner,
        a {
            word-break: break-all;
            display: flex;
            color: @text-color;
        }

        i.glyphicon {
            margin-right: 7px;
        }
    }
</style>

<script>
    import {getAddressLink} from '../../utils';
    import Vue from 'vue';
    export default {
        computed: {
            /**
             * Depending on the of contact, we want the first line to contains
             * the position or the name
             * @returns String
             */
            firstLine() {
                if (this.isCompanyContact || !this.contact.position) {
                    return `${Vue.filter('shortTitle')(this.contact.title)}
                    ${this.contact.first_name} ${this.contact.last_name} `;
                }
                return this.contact.position;
            },
            /**
             * Depending on the of contact, we want the title to contains the
             * position or the name
             * @returns String
             */
            headTitle() {
                if (!this.isCompanyContact || !this.contact.position) {
                    return `${Vue.filter('shortTitle')(this.contact.title)}
                    ${this.contact.first_name} ${this.contact.last_name} `;
                }
                return this.contact.position;
            }
        },
        props: {
            contact: Object,
            className: {
                type: String,
                default: ''
            },
            isCompanyContact: {
                type: Boolean,
                default: false
            },
            showEditModal: Function
        },
        methods: {
            /**
             * Parse the json encoded address and return a link to gmaps
             * @param sourceJson
             * @returns {string}
             */
            addressLink(sourceJson) {
                const {formatted_address} = JSON.parse(sourceJson);
                return getAddressLink(formatted_address);
            }
        },
        name: 'contact-box'
    };
</script>



// WEBPACK FOOTER //
// ContactBox.vue?26c31f6e